module.exports = __webpack_public_path__ + "static/media/josefin1.15ad1a99.webp";